import { getCurrentScope } from '@sentry/browser'

import { closeDialog } from '@main/actions/signinOrRegisterDialog'
import { VIEW_MODE_BASIC, VIEW_MODE_MANAGEMENT } from '@h2/common/constants'
import { setUser } from '@h2/common/actions/setUser'
import { setAuthenticationState } from '@main/actions/index'
import { unauthorizedUserAuthenticated } from '@h2/common/actions/unauthorizedUserAuthenticated'
import { browserHistory } from '@main/util/browserHistory'

export const verifyMembership = membership => dispatch => {
  const { authorizationCode } = membership

  if (authorizationCode) {
    dispatch(unauthorizedUserAuthenticated(authorizationCode))
  }

  browserHistory.push({ pathname: '/accept' })
}

export const startSession =
  ({ user, environment, setViewMode }) =>
  dispatch => {
    setViewMode(user.managementDashboardView ? VIEW_MODE_MANAGEMENT : VIEW_MODE_BASIC)
    dispatch(setUser(user))
    /*
     *  Legacy redux store location
     * console.log("setAuthenticationState", setAuthenticationState)
     * console.log("setAuthenticationState(user)", setAuthenticationState(user))
     */
    dispatch(setAuthenticationState(user))

    // Update Sentry user
    if (['production', 'staging'].includes(environment)) {
      const scope = getCurrentScope()

      scope.setUser({
        id: user.id,
        email: user.email,
        username: user.userName
      })
      scope.setExtra('userProfile', user)
    }
  }

export const sessionStarted =
  ({ inDialog, postSigninURI, pathname, onRedirect, onNoRedirect }) =>
  dispatch => {
    const redirectPath = postSigninURI ?? '/'
    const isHomePage = page => page === '/' || page === '/index'
    const isRedirecting =
      /*
       * If we're not in a dialog, then we always redirect, this basically only happens when
       * we signin from the signin page
       */
      !inDialog ||
      /*
       * if we are in a dialog, then only redirect if
       *  We signed in from the home page, and the redirect page _isn't_ the home page
       */
      (isHomePage(pathname) && !isHomePage(redirectPath))
    const isAuth =
      pathname?.startsWith('/signin') ||
      pathname?.startsWith('/register') ||
      pathname?.startsWith('/accept')

    if (isRedirecting || (isAuth && inDialog)) {
      if (postSigninURI) {
        document.cookie = 'originPage=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/'
      }

      onRedirect?.()

      return window.location.replace(redirectPath)
    }

    onNoRedirect?.()

    if (inDialog) {
      dispatch(closeDialog())
    }
  }
